<template>
    <div class="template-base">
        <Header Title="Site Switch" :iconPath="'/images/icons/switch.png'" class="div-header"></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit"></Button>
            <Button style="border: 3px solid" class="x-smaller-button" :buttonModel="btnMove" @on-clicked="moveSites" :disable="fetchingData || (toVnext.length == 0 && toPortal.length == 0)" />

            <!-- Header-->
            <div style="display:flex; height: 50px;"></div>
        </div>

        <div style="margin: 40px;">
            Select the tenants to move to other site. Then click the Move button above.
        </div>

        <div style="display: flex; flex-direction: row; align-items: center;height: 80%;">
            <div style="margin:10px" class="switcher-container">
                <!-- Portal -->
                <div class="switcher-site-container">
                    <!-- Title and Buttons -->
                    <div style="width:100%; display: flex; flex-direction: row;justify-content: space-between;">
                        <div style="font-size: 18pt;">Portal ({{ toVnext.length }})</div>
                        <div style="width: 50%; display: flex; flex-direction: row;justify-content: flex-end;">
                            <div class="switcher-button" @click="toVnext = listPortal.map((t) => t.tenantId)">All</div>
                            <div class="switcher-button" @click="toVnext = []">Clear</div>
                        </div>
                    </div>

                    <!-- List -->
                    <div class="switcher-checkbox-list">
                        <div v-for="(tenant, index) in listPortal" :key="tenant.tenantId" class="switcher-checkbox-row" @click="handleClickToVNext($event, tenant, index)">
                            <label :class="{ selected: toVnext.includes(tenant.tenantId) }">
                                <input type="checkbox" :value="tenant.tenantId" v-model="toVnext" @click.stop />
                                {{ tenant.tenantName }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="switcher-site-container">
                    <!-- Title and Buttons -->
                    <div style="width:100%; display: flex; flex-direction: row;justify-content: space-between;">
                        <div style="font-size: 18pt;">vNext ({{ toPortal.length }})</div>
                        <div style="width: 50%; display: flex; flex-direction: row;justify-content: flex-end;">
                            <div class="switcher-button" @click="toPortal = listVNext.map((t) => t.tenantId)">All</div>
                            <div class="switcher-button" @click="toPortal = []">Clear</div>
                        </div>
                    </div>

                    <!-- List -->
                    <div class="switcher-checkbox-list">
                        <div v-for="(tenant, index) in listVNext" :key="tenant.tenantId" class="switcher-checkbox-row" @click="handleClickToPortal($event, tenant, index)">
                            <label :class="{ selected: toPortal.includes(tenant.tenantId) }">
                                <input type="checkbox" :value="tenant.tenantId" v-model="toPortal" @click.stop/>
                                {{ tenant.tenantName }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import { getCurrentInstance, ref } from "vue";
import { onMounted } from "@vue/runtime-core";
import Helper from "@/common/helper";
import Utilities from "@/common/utilities";
import apiTenant from "@/api/apiTenant";

export default {
    components: { Header, Button },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnMove = ButtonModel.CreateClick("");
        btnMove.iconPath = "/images/icons/swap.png";
        btnMove.title = "Move tenants...";

        const listPortal = ref([]);
        const listVNext = ref([]);

        const toVnext = ref([]);
        const toPortal = ref([]);

        onMounted(async () => {
            await getData();
        });

        const getData = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;
                var items = await apiTenant.getTenantTimezoneList();
                listPortal.value = [];
                listVNext.value = [];
                toPortal.value = [];
                toVnext.value = [];
                items.forEach((item) => {
                    if (item.isVNext) {
                        listVNext.value.push(item);
                    } else {
                        listPortal.value.push(item);
                    }
                });
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        const moveSites = async () => {
            let result = confirm("Are you sure you want to move selected sites and reboot their stations?");
            if (result) {
                try {
                    emitter.emit("server-call-start", "Loading...");
                    fetchingData.value = true;
                    await apiTenant.switchSites(toPortal.value, toVnext.value);
                } catch (err) {
                    console.log("ERROR:", err);
                    emitter.emit("show-alert", ["Error loading data", err]);
                }
                emitter.emit("server-call-stop");

                await getData();
            }
        };

        const lastIndex = ref(null);
        function handleClickToVNext(event, tenant, index) {
            const id = tenant.tenantId;

            if (event.shiftKey && lastIndex.value !== null) {                
                // --- SHIFT: select a range between last clicked and current ---
                const [start, end] = [lastIndex.value, index].sort((a, b) => a - b);
                const rangeIds = listPortal.value.slice(start, end + 1).map((t) => t.tenantId);
                const set = new Set([...toVnext.value, ...rangeIds]);
                toVnext.value = [...set];
            } else if (event.metaKey || event.ctrlKey) {
                // --- CTRL/CMD: toggle current one ---
                if (toVnext.value.includes(id)) {
                    toVnext.value = toVnext.value.filter((x) => x !== id);
                } else {
                    toVnext.value.push(id);
                }
            } else {                                
                if (toVnext.value.includes(id)){
                    toVnext.value.splice(toVnext.value.indexOf(id), 1)
                }
                else {
                    toVnext.value.push(id);
                }
            }            
            lastIndex.value = index;
        }

        function handleClickToPortal(event, tenant, index) {
            const id = tenant.tenantId;

            if (event.shiftKey && lastIndex.value !== null) {                
                // --- SHIFT: select a range between last clicked and current ---
                const [start, end] = [lastIndex.value, index].sort((a, b) => a - b);
                const rangeIds = listVNext.value.slice(start, end + 1).map((t) => t.tenantId);
                const set = new Set([...toPortal.value, ...rangeIds]);
                toPortal.value = [...set];
            } else if (event.metaKey || event.ctrlKey) {
                // --- CTRL/CMD: toggle current one ---
                if (toPortal.value.includes(id)) {
                    toPortal.value = toPortal.value.filter((x) => x !== id);
                } else {
                    toPortal.value.push(id);
                }
            } else {                                
                if (toPortal.value.includes(id)){
                    toPortal.value.splice(toPortal.value.indexOf(id), 1)
                }
                else {
                    toPortal.value.push(id);
                }
            }            
            lastIndex.value = index;
        }

        return {
            btnExit,
            btnMove,
            Helper,
            Utilities,
            fetchingData,
            listPortal,
            listVNext,
            toVnext,
            toPortal,
            moveSites,
            handleClickToVNext,
            handleClickToPortal
        };
    }
};
</script>

<style scoped>
.switcher-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    /* padding: 20px 30px;
    border-radius: 10px; */
    /* box-shadow: 0 0 10px rgba(0,0,0,0.15); */
    width: 100%;
    height: 100%;
}

.switcher-site-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 45%;
    height: 100%;
    /* background-color: red; */
}

.switcher-select {
    width: 100%;
    height: 90%;
}
.switcher-buttons {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 20px;
}

.switcher-checkbox-list {
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 4px;
    background: #fff;
    width: 100%;
    height: 90%;
}

.switcher-checkbox-row {
    cursor: pointer;
    padding: 4px;
    user-select: none;
}
.switcher-checkbox-row:hover {
    background-color: #f3f3f3;
}

.switcher-button {
    color: var(--button-color);
    padding: 4px;
    margin-right: 10px;
    width: 70px;
    cursor: pointer;
    text-align: center;
    border: 1px solid black;
}


</style>
